import { faCloudDownload, faCommentLines, faLayerGroup } from "@fortawesome/pro-solid-svg-icons"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import { Box, Container, Grid, Typography } from "@mui/material"
import { styled } from "@mui/material/styles"
import { useApi } from "auth/useApi3"
import { DangerousHtml } from "components/DangerousHtml"
import { GlobalLoaderContext } from "components/GlobalLoadingProvider"
import PaperBox from "components/PaperBox"
import { SkeletonCard } from "components/skeleton/SkeletonCard"
import { apiEndpoints } from "generated/apiEndpoints"
import { ExaminationMiniInfoCard } from "pages/learning/pages/user/components/ExaminationMiniInfoCard/ExaminationMiniInfoCard"
import { ExaminationPdfLinkCard } from "pages/learning/pages/user/components/ExaminationPdfLinkCard"
import { useContext, useEffect, useState } from "react"
import { useTranslation } from "react-i18next"

const StyledStartGrid = styled(Grid)({
  justifyContent: "flex-start",
  alignItems: "center"
})

const StyledGrid = styled(Grid)({
  display: "flex"
})

const StyledFontAwesomeIcon = styled(FontAwesomeIcon)(({ theme }) => ({
  color: theme.palette.primary["700"],
  marginRight: 8
}))

const ExamDetails = (props) => {
  const { t } = useTranslation()
  const courseDetails = t("learning.details.course", { returnObjects: true })

  const loadingContext = useContext(GlobalLoaderContext)
  const { match } = props
  const korVilaSwedish = process.env.PUBLIC_URL + "/assets/learning/DrivingRest_Swe.pdf"
  const korVilaEnglish = process.env.PUBLIC_URL + "/assets/learning/DrivingRest_Eng.pdf"

  const [examResult, examFuncs] = useApi()
  const [examinationType, setExaminationType] = useState()

  useEffect(() => {
    examFuncs.get(apiEndpoints.learning.getassignedexaminationdetails.replace("{id}", match.params.id))
  }, [examFuncs, match])
  useEffect(() => {
    loadingContext.setLoading(() => examResult.status === 1)
  })

  useEffect(() => {
    if (examResult && examResult.status === 2) {
      setExaminationType(examResult.data.examinationType)
    }
  }, [examResult])

  let courseDetail = null
  if (examinationType && examResult.status === 2) {
    courseDetail =
      Array.isArray(courseDetails) &&
      courseDetails.find((course) => course.examinationType === examinationType)
  }

  return (
    <>
      <Container>
        {examResult.status === 2 ? (
          <Typography variant="h1" mb={5}>
            {courseDetail ? courseDetail?.examinationName : examResult.data.examinationName}
          </Typography>
        ) : (
          <SkeletonCard />
        )}

        <Grid container spacing={2}>
          <Grid item xs={12} md={12} lg={8}>
            <PaperBox sx={{ marginTop: 0 }}>
              <Box marginBottom={2}>
                {examResult.status === 2 ? (
                  <StyledStartGrid container direction="row" spacing={2}>
                    <StyledGrid item>
                      <StyledFontAwesomeIcon icon={faLayerGroup} />
                      <Typography variant="bodySmall">
                        {examResult.data.examinationAreaCount} {t("learning.titles.segments", "segments")}
                      </Typography>
                    </StyledGrid>
                    <StyledGrid item>
                      <StyledFontAwesomeIcon icon={faCommentLines} />
                      <Typography variant="bodySmall">
                        {examResult.data.examinationQuestionCount}{" "}
                        {t("learning.titles.questions", "questions")}
                      </Typography>
                    </StyledGrid>
                  </StyledStartGrid>
                ) : (
                  <SkeletonCard />
                )}
              </Box>
              {examResult.status === 2 ? (
                <>
                  <Typography variant="bodyMedium" gutterBottom>
                    <DangerousHtml>
                      {courseDetail
                        ? courseDetail?.examinationDescription
                        : examResult.data.examinationDescription}
                    </DangerousHtml>
                  </Typography>
                  <Typography variant="bodyMedium">
                    <DangerousHtml>
                      {courseDetail
                        ? courseDetail?.examinationDefinition.subTitle
                        : examResult.data.examinationDefinition.subTitle}
                    </DangerousHtml>
                  </Typography>
                  <Typography variant="bodyMedium">
                    <DangerousHtml>
                      {courseDetail
                        ? courseDetail?.examinationDefinition.description
                        : examResult.data.examinationDefinition.description}
                    </DangerousHtml>
                  </Typography>
                </>
              ) : (
                <SkeletonCard />
              )}
            </PaperBox>
          </Grid>
          <Grid item xs={12} md={12} lg={4}>
            {examResult.status === 2 ? <ExaminationMiniInfoCard item={examResult.data} /> : <SkeletonCard />}
            {examResult.status === 2 ? (
              examResult.data.examinationType === "KorVila1" ||
              examResult.data.examinationType === "KorVilaFreightTraffic" ? (
                <>
                  <ExaminationPdfLinkCard
                    icon={faCloudDownload}
                    pdf={korVilaSwedish}
                    title={`${t("learning.details.titles.download", "Download study material")} (${t("global.swedish", "Swedish")})`}
                  />
                  <ExaminationPdfLinkCard
                    icon={faCloudDownload}
                    pdf={korVilaEnglish}
                    title={`${t("learning.details.titles.download", "Download study material")} (${t("global.english", "English")})`}
                  />
                </>
              ) : null
            ) : (
              <SkeletonCard />
            )}
          </Grid>
        </Grid>
      </Container>
    </>
  )
}
export default ExamDetails
